import { __spreadArray } from "tslib";
// DS: C119B
import React, { useMemo, Fragment, useContext } from 'react';
import classnames from 'classnames';
import Heading from '../../a11y/headings/Heading';
import ChatThumbnail from '../ChatThumbnail';
import { ChatParticipantDisplayDataTypes, } from '../redux/types';
import get from 'lodash/get';
import ChatUserLink from '../ChatUserLink';
import UserAvatarStack from '../UserAvatarStack';
import { getMultiChatStackInfo, toDisplayData, } from '../ChatSummaryItem/helpers';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import SimpleHoverPopperPopover from '../../Popover/Preset/SimpleHoverPopperPopover';
import s from './ChatTitleBlock.scss';
export var ChatTitleBlock = function (_a) {
    var chatroom = _a.chatroom, className = _a.className, avatarClassName = _a.avatarClassName, currentUser = _a.currentUser, withUserlistHover = _a.withUserlistHover, thumbnailDataHook = _a.thumbnailDataHook;
    var isMobile = useContext(MobileContext);
    var includeUserlist = !isMobile && withUserlistHover;
    var _b = useMemo(function () { return getChatInfoFromChatroom(chatroom, currentUser, includeUserlist); }, [chatroom, currentUser, includeUserlist]), thumbnail = _b.thumbnail, name = _b.name;
    if (!chatroom) {
        return React.createElement("div", null, "Failed to render chatroom");
    }
    return (React.createElement("div", { className: classnames(s['root'], className) },
        Array.isArray(thumbnail) && (React.createElement(UserAvatarStack, { users: thumbnail, "data-hook": thumbnailDataHook })),
        !Array.isArray(thumbnail) && (React.createElement(ChatThumbnail, { src: thumbnail, avatarClassName: avatarClassName, "data-hook": thumbnailDataHook })),
        React.createElement(Heading, { className: s['chat-name'] }, name)));
};
ChatTitleBlock.displayName = 'ChatTitleBlock';
function getChatInfoFromChatroom(chatroom, currentUser, includeUserList) {
    if (!chatroom) {
        return {
            thumbnail: '',
            name: '???',
        };
    }
    // Wix has different set of types
    var chatType = chatroom.siteUserType;
    // Chat has been renamed
    if (chatType === ChatParticipantDisplayDataTypes.ROOM) {
        var lastSender = undefined;
        if (get(chatroom, 'lastMessage')) {
            lastSender = toDisplayData(get(chatroom, 'lastMessage.senderDisplayData'));
        }
        else {
            var messages = get(chatroom, 'messages');
            if (messages) {
                lastSender = toDisplayData(get(messages[messages.length - 1], 'senderDisplayData'));
            }
        }
        return {
            thumbnail: get(lastSender, 'displayData.image.url', ''),
            name: chatroom.name,
        };
    }
    // Multi chat
    if (!chatroom.isPrivate) {
        var infoStack_1 = getMultiChatStackInfo(chatroom, currentUser);
        // Build usernames format of: {username}, {username}...
        var name_1 = '';
        if (infoStack_1.length > 0) {
            name_1 = infoStack_1.map(function (participant, idx) { return (React.createElement(Fragment, { key: chatroom.id + "-" + participant.displayData.name + "-info-link" },
                React.createElement(ChatUserLink, { participant: participant, noLink: true, "data-hook": "specific_chat_member_" + idx }),
                idx !== infoStack_1.length - 1 && React.createElement(React.Fragment, null, ",\u00A0"))); });
        }
        else {
            name_1 = '';
        }
        if (includeUserList) {
            name_1 = (React.createElement(SimpleHoverPopperPopover, { placement: "bottom", secondaryPlacement: "start", hoverDelay: 2000, showArrow: false, className: s['userlist-wrapper'], popoverContent: React.createElement("ul", { "aria-hidden": true }, __spreadArray([], infoStack_1).sort(function (a, b) {
                    return a.displayData.name.localeCompare(b.displayData.name);
                })
                    .map(function (user, index) { return (React.createElement("li", { key: user.id },
                    React.createElement(ChatUserLink, { participant: user, "data-hook": "specific_chat_member_" + index }))); })) },
                React.createElement("div", { className: s['userlist'] }, name_1)));
        }
        return {
            thumbnail: infoStack_1,
            name: name_1,
        };
    }
    // DM case
    return {
        thumbnail: chatroom.thumbnail || '',
        name: (React.createElement(ChatUserLink, { noLink: true, participant: toDisplayData({
                name: chatroom.name,
                initials: chatroom.initials,
                image: { url: chatroom.thumbnail || '' },
            }), "data-hook": 'specific_chat_member_0' })),
    };
}
export default ChatTitleBlock;
//# sourceMappingURL=ChatTitleBlock.js.map